import { getConfig } from './config';

const currentConfig = getConfig();
export const API_URL = currentConfig.ea.baseUrl;
export const AUTH_CLIENT_ID = currentConfig.auth.clientId;
export const AUTH_URL = currentConfig.auth.url;
export const APP_URL = currentConfig.appUrl;
export const LOGGER_CONFIG = currentConfig.logging;
